// extracted by mini-css-extract-plugin
export default {"promo-input__apply-button":"mAZF70It--PromoCodeInput_promo-input__apply-button__0Esg-","promoInputApplyButton":"mAZF70It--PromoCodeInput_promo-input__apply-button__0Esg-"};